import {saveownerData} from "../Infrastructure/DashboardOwner.store";
import {getOwnerDataLogic} from "./DashboardOwner.logic";
import Storage from "../../Data/Domain/Storage";

export async function getDashboardOwnerData(project_id) {
  const internal_id = new Storage("id").getItem();

  const ownerData = await getOwnerDataLogic(internal_id, project_id);
  saveownerData(ownerData);
}
